export const FORECASTING_FETCH_SCENARIOS = 'FORECASTING_FETCH_SCENARIOS';
export const FORECASTING_ADD_PROJECTION_SCENARIO = 'FORECASTING_ADD_PROJECTION_SCENARIO';
export const FORECASTING_UPDATE_PROJECTION_SCENARIO = 'FORECASTING_UPDATE_PROJECTION_SCENARIO';
export const FORECASTING_DELETE_PROJECTION_SCENARIO = 'FORECASTING_DELETE_PROJECTION_SCENARIO';
export const FORECASTING_SCENARIO_DISPLAY_MODE = 'FORECASTING_SCENARIO_DISPLAY_MODE';
